function textCleanup(l) {
  if (/^\d/.test(l)) l = l.slice(2)
  if (l.includes(';-')) l = l.slice(0, l.indexOf(';'))
  if (l.includes(')')) l = l.slice(0, l.indexOf(')') + 1)
  l = l.replace(';-', '')
  return l
}

function ToggleTile({ label, active, onClick }) {
  return (
    <button
      className={`present-toggle-tile frosted ticks${active ? ' present-toggle-tile--active ticks--active' : ''}`}
      onClick={onClick}
    >
      <span className="present-toggle-icon">{active ? '✓' : '⊘'}</span>
      <span className="present-toggle-label fs-6">{label}</span>
    </button>
  )
}

function PresentControls({ activeTile, outputLang, onOutputLangToggle, overlay, onOverlayToggle, isLive, onLiveToggle }) {
  return (
    <div className="present-controls">
      <div className="present-controls-preview">
        {activeTile && overlay === null && (
          <div className="present-preview-verse">
            <div className="present-tile-label fg-ac1">{activeTile.label}</div>
            {outputLang.en && activeTile.verse && activeTile.verse.map((line, i) => (
              <div key={`en-${i}`} className="fg-l1 fs-6">{textCleanup(line)}</div>
            ))}
            {outputLang.ml && activeTile.verse2 && activeTile.verse2.map((line, i) => (
              <div key={`ml-${i}`} className="fg-l2 fs-6">{textCleanup(line)}</div>
            ))}
          </div>
        )}
        {overlay === 'clear' && (
          <div className="present-preview-overlay fs-6 fg-l2" style={{ opacity: 0.3 }}>Clear</div>
        )}
        {overlay === 'black' && (
          <div className="present-preview-overlay fs-6" style={{ background: '#000', color: '#333' }}>Black</div>
        )}
      </div>

      <div className="present-controls-toggles">
        <button
          className={`present-live-btn frosted ticks fs-6${isLive ? ' ticks--live' : ''}`}
          onClick={onLiveToggle}
        >
          {isLive ? 'LIVE' : 'Go Live'}
        </button>
        <div className="present-toggle-row">
          <ToggleTile label="English" active={outputLang.en} onClick={() => onOutputLangToggle('en')} />
          <ToggleTile label="മലയാളം" active={outputLang.ml} onClick={() => onOutputLangToggle('ml')} />
        </div>
        <div className="present-toggle-row">
          <ToggleTile label="Clear" active={overlay === 'clear'} onClick={() => onOverlayToggle('clear')} />
          <ToggleTile label="Black" active={overlay === 'black'} onClick={() => onOverlayToggle('black')} />
        </div>
      </div>
    </div>
  )
}

export default PresentControls
